document.addEventListener('cmplz_banner_status', function(e) {
  let closeButtonSvgTitle, cmplzCloseButtonElement;

  if (e.detail === 'show') {
    cmplzCloseButtonElement = document.querySelector('.cmplz-close');
    closeButtonSvgTitle = cmplzCloseButtonElement.querySelector('svg title');
    if (closeButtonSvgTitle) {
      closeButtonSvgTitle.textContent = null;
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  let manage_consent_items;

  manage_consent_items = document.querySelectorAll('.cmplz-show-banner');
  manage_consent_items.forEach(function(item) {
    item.addEventListener('click', function() {
      let cmplz_button;

      cmplz_button = document.querySelector('.cmplz-btn.cmplz-manage-consent');
      cmplz_button.click();
    });
  });
});

// Remove cookies after revoke consents
const excludeCookies = [
  'wp',
  'wordpress',
  'cmplz_banner-status',
  'cmplz_functional',
  'cmplz_marketing',
  'cmplz_policy_id',
  'cmplz_preferences',
  'cmplz_statistics'
];

const cookieExcluded = function(cookieName) {
  let exclude, excluded, i, len;

  excluded = false;
  for (i = 0, len = excludeCookies.length; i < len; i++) {
    exclude = excludeCookies[i];
    if (cookieName.indexOf(exclude) >= 0) {
      excluded = true;
    }
  }
  return excluded;
};

const cmplzClearAllCookies = function() {
  let cookie, cookies, i, len;

  cookies = document.cookie.split("; ");

  for (i = 0, len = cookies.length; i < len; i++) {
    let cookieBase, cookieName, hosts, paths;

    cookie = cookies[i];
    hosts = window.location.hostname.split(".");

    if (hosts.length > 0) {
      while (true) {
        cookieName = cookie.split(";")[0].split("=")[0];
        cookieBase = encodeURIComponent(cookieName) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + hosts.join('.') + ' ;path=';
        paths = location.pathname.split('/');

        if (!cookieExcluded(cookieName)) {
          document.cookie = cookieBase + '/';

          if (paths.length > 0) {
            while (true) {
              document.cookie = cookieBase + paths.join('/');
              paths.pop();

              if (paths.length === 0) { break; }
            }
          }
        }

        hosts.shift();
        if (hosts.length === 0) { break; }
      }
    }
  }
};

document.addEventListener('cmplz_revoke', function(e) {
  cmplzClearAllCookies();
});
